// extracted by mini-css-extract-plugin
module.exports = {"colText":"AcceptanceDetailsHeader_colText__2Jm7o"};